import {useEffect} from 'react'

export default refEl => {
    useEffect(
        () => {
            const onFocusOut = e => {
                if (e.relatedTarget) {
                    return
                }

                setTimeout(() => {
                    if (
                        ! e.target.isConnected &&
                        document.activeElement === document.body
                    ) {
                        refEl.current?.focus()
                    }
                })
            }

            window.addEventListener('focusout', onFocusOut)
            return () => window.removeEventListener('focusout', onFocusOut)
        },

        []
    )
}
